module.exports = __webpack_public_path__ + "static/favicons/favicon-96x96-a9e61c652c21726759267c2a973d46fd.png";